import { render, staticRenderFns } from "./VectorizationManagementSincronizeData.vue?vue&type=template&id=127855c0&scoped=true"
import script from "./VectorizationManagementSincronizeData.vue?vue&type=script&lang=js"
export * from "./VectorizationManagementSincronizeData.vue?vue&type=script&lang=js"
import style0 from "./VectorizationManagementSincronizeData.vue?vue&type=style&index=0&id=127855c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127855c0",
  null
  
)

export default component.exports